export default "__VITE_ASSET__CXoszFvd__"